import { render, staticRenderFns } from "./fbaMailingAddress.vue?vue&type=template&id=5ec39548&scoped=true&"
import script from "./fbaMailingAddress.vue?vue&type=script&lang=js&"
export * from "./fbaMailingAddress.vue?vue&type=script&lang=js&"
import style0 from "./fbaMailingAddress.vue?vue&type=style&index=0&id=5ec39548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec39548",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ec39548')) {
      api.createRecord('5ec39548', component.options)
    } else {
      api.reload('5ec39548', component.options)
    }
    module.hot.accept("./fbaMailingAddress.vue?vue&type=template&id=5ec39548&scoped=true&", function () {
      api.rerender('5ec39548', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/FBA/fbaMailingAddress.vue"
export default component.exports